import { html, SYSBaseElement } from "../../../../../../../_ovlclient/src"

import { T, D } from "../../../../../../../_ovlclient/src/global/globals"

export class CompOrderDetail extends SYSBaseElement {
  async getUI() {
    let key = this.state.app.screens.DATOrder.orderDetailFormState.selectedOrder
    let order = this.state.app.screens.DATOrder.orderDetail.orders[key]
    let channelExtension = undefined

    if (order.orderType === "channel") {
      channelExtension = html`<span
          class="portal-orderdetail-orderforchannel-value"
          >${T("DATDocumentDataOrderForChannel")}</span
        >&nbsp;<span class="portal-orderdetail-orderforchannelname-value"
          >${this.state.ovl.user.cardName}</span
        >`
    }
    return html`
      <div class="fd-layout-panel">
        <div class="fd-layout-panel__header">
          <div class="fd-layout-panel__head">
            <h3 class="fd-layout-panel__title">${T("GENDetails")}</h3>
          </div>
        </div>
        <div class="fd-layout-panel__body">
          <div class="ovlcols2">
            <div class="portal-orderdetail-cardcode-label">
              ${T("GENCardCode")}
            </div>
            <div class="portal-orderdetail-cardcode-value">
              ${order.cardCode}
            </div>
            <div class="portal-orderdetail-cardname-label">
              ${T("GENCardName")}
            </div>
            <div class="portal-orderdetail-cardname-value">
              ${order.cardName} ${channelExtension}
            </div>

            <div class="portal-orderdetail-docnum-label">
              ${T("DATDocumentDataOrderDocNum")}
            </div>
            <div class="portal-orderdetail-docnum-value">${key}</div>

            <div class="portal-orderdetail-docdate-label">
              ${T("DATDocumentDataOrderDocDate")}
            </div>
            <div class="portal-orderdetail-docdate-value">
              ${D(order.docDate)}
            </div>

            <div class="portal-orderdetail-deliverydate-label">
              ${T("DATDocumentDataDeliveryDate")}
            </div>
            <div class="portal-orderdetail-deliverydate-value">
              ${D(order.deliveryDate)}
            </div>

            <div class="portal-orderdetail-commission-label">
              ${T("GENCommission")}
            </div>
            <div class="portal-orderdetail-commission-value">
              ${order.refNum}
            </div>
          </div>
        </div>
      </div>
    `
  }
}
